/**
 * 헤더에 표시할 문구를 설정한다.
 * @param {*} state 
 * @param {string} subtitle - 헤더에 표시할 문구
 */
const SET_SUBTITLE = (state, subtitle) => state.subtitle = subtitle
/**
 * 헤더에 표시할 버튼 타입을 설정한다.
 * @param {*} state 
 * @param {string} type - 헤더에 표시할 버튼 타입
 */
const SET_BUTTON_TYPE = (state, type) => state.buttonType = type
/**
 * 헤더에 이전 버튼 표시 여부를 설정한다.
 * @param {*} state 
 * @param {Boolean} show -표시 여부
 */
const SHOW_PREV_BUTTON = (state, show) => state.isShowPrevButton = show

export default {
  SET_SUBTITLE,
  SET_BUTTON_TYPE,
  SHOW_PREV_BUTTON
}
